/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * Severity of the alert
 */
export type AlertSeverity = (typeof AlertSeverity)[keyof typeof AlertSeverity]

export const AlertSeverity = {
  info: "info",
  warning: "warning",
  critical: "critical",
  success: "success",
} as const
